import { connect } from 'react-redux';
import { Header } from '@is24at/header';
import { byUser, byIsLoggedIn, byEmail } from '@is24at/react-redux';

const mapStateToProps = (state: any) => ({
  account: byUser(state)?.account || {},
  isLoggedIn: byIsLoggedIn(state),
  email: byEmail(state),
});

export default connect(mapStateToProps)(Header);
